import { HeaderGroup } from 'react-table';

import { Icon } from 'components/Icon';

import * as S from './Head.styles';

type HeadProps = {
  headerGroups: HeaderGroup<{}>[];
  isSortable?: boolean;
  additionalHeaders?: React.ReactNode;
};

export function Head(props: HeadProps): React.ReactElement {
  const { headerGroups, isSortable = false, additionalHeaders = undefined } = props;

  return (
    <S.Head isMultipleHeaders={additionalHeaders !== undefined}>
      {additionalHeaders}

      {headerGroups.map((headerGroup) => (
        <S.TR
          {...headerGroup.getHeaderGroupProps()}
          key={headerGroup.getHeaderGroupProps().key}
        >
          {headerGroup.headers.map((column) => (
            <S.TH
              {...column.getHeaderProps(
                isSortable ? column.getSortByToggleProps() : undefined
              )}
              key={column.getHeaderProps().key}
              id={column.getHeaderProps().key.toString()}
            >
              {isSortable ? (
                <S.THWrapper>
                  {column.render('Header')}

                  <S.IconWrapper>
                    {column.isSorted && (
                      <Icon name={column.isSortedDesc ? 'FiArrowDown' : 'FiArrowUp'} />
                    )}
                  </S.IconWrapper>
                </S.THWrapper>
              ) : (
                column.render('Header')
              )}
            </S.TH>
          ))}
        </S.TR>
      ))}
    </S.Head>
  );
}
